export const SKILL_LIST = [{
  img: 'eventDriven.png',
  title: '事件驱动',
  desc: '监测全网金融类事件，感知市场热点，回测收益幅度'
}, {
  img: 'opinionWarning.png',
  title: '舆情预警',
  desc: '实时监测新闻、资讯、公告、研报等各种消息源，及时推送标的正负舆情走势和事件舆情信息'
}, {
  img: 'IntelligentAnnouncement.png',
  title: '智能公告',
  desc: '对上市公司公告进行自动分类和关键事件元素自动抽取，例如增发、减持、并购、重组等'
}, {
  img: 'researchReport.png',
  title: '研报解析',
  desc: '收录市场上公开的第三方研报成果，供分析师查看和参考，准确把控当前市场研究方向'
}, {
  img: 'DataVisualization.png',
  title: '数据可视化',
  desc: '自动从研报的图片和表格中提取数据，将其进行可视化展示并持续予以入库及更新'
}, {
  img: 'IndustrialMap.png',
  title: '产业图谱',
  desc: '以2.5d形式展现7大主要行业的90多个子行业产业链上下游关系，支持修改或构建专属图谱'
}, {
  img: 'DynamicDeduction.png',
  title: '动态推演',
  desc: '搭建研究框架并赋以舆情监控、异动提醒、事件传导等功能，支持个性化投研框架搭建等操作'
}, {
  img: 'knowledgeGraph.png',
  title: '知识图谱',
  desc: '依托NLP技术，通过对数据间的关系建立图谱，为企业的商业决策提供参考'
}, {
  img: 'IntelligentAudit.png',
  title: '智能审核',
  desc: '对研究报告中的标点、文字、图表、财务勾稽关系等内容进行智能审核'
}];
export const SCENE_LIST = [{
  icon: 'jhjrssyq-icon.png',
  bg: 'engine.png',
  title: '聚合金融搜索引擎',
  desc: '聚合金融搜索一搜即达，一搜整合全部底层数据，降低学习及搜索成本。自然语言搜问句，搜功能，搜资讯，是研究员的金融知识管家，贴心的投资助手'
}, {
  icon: 'FusionCenter-icon.png',
  bg: 'FusionCenter.png',
  title: '数据融合中心',
  desc: '融合多方数据库及同花顺AI技术，帮助研究员解决数据采集难、数据处理难、数据不可视化的问题，提高研究员的生产力，让数据创造出更多的价值'
}, {
  icon: 'tybg-icon.png',
  bg: 'tybg.png',
  title: '投研管理平台',
  desc: '投研工作区可解决研究员之间的协同分析差、研究员与基金经理之间的沟通难、买方和卖方之间研究成果孤立、研究员和客户之间没有交流渠道等问题，在提供投研工作效率的同时，将研究员的研究过程和研究成果留痕备份'
}, {
  icon: 'znyb-icon.png',
  bg: 'researchbg.png',
  title: '智能研报',
  desc: '自动生成基础的公司及行业报告，就研究员撰写的研究报告进行智能文本查重及审核，将研究员从简单但是非常耗时耗力的基础研报工中解放出来，节省了研究员大量的时间，从而把精力投入到更重要的投资分析'
}];
export const FEATURES_LIST = [{
  title: '提高数据处理质效',
  desc: '智能投研系统能够帮助研究员高效搜集、处理更多的信息，先人一步捕捉到二级市场的投资机会',
  img: 'investment-research/qualityS.jpg'
}, {
  title: '提升信息共享水平',
  desc: '提高研究员之间的信息共享和沟通效率，帮助新人快速接手前任研究员的成果',
  img: 'investment-research/ImproveLevel.jpg'
}, {
  title: '节省研究成本',
  desc: '智能投研系统可以替代一部分研究员助理和初级研究员的信息收集工作，减少人力成本的支出',
  img: 'investment-research/saveCost.jpg'
}, {
  title: '增强研究所核心竞争力',
  desc: '智能投研系统帮助投研人员打造更加标准化、规范化、流程化的一站式投研工具，最终增强研究所核心竞争力',
  img: 'investment-research/StrengthenA.jpg'
}];